/**
 * @description 加载vconsole
 */

const loadVconsole = function(){
    if(NODE_ENV === 'test' || NODE_ENV === 'pre'){
        import(/* webpackChunkName: "dynamic4vconsole" */'vconsole').then(module => {
            const vconsole = new module.default()
        }).catch(error => {
            console.log('vconsole加载失败', error)
        })
    }
}

export default loadVconsole